// ─── Free-gift pairing constants ────────────────────────────────────────────
if (typeof BAT_PRODUCT_IDS === 'undefined') {
  var BAT_PRODUCT_IDS      = new Set([1558412951604, 7252607041634, 6841255559266, 10345704095842, 10345739092066]);
  var BLUEPRINT_PRODUCT_ID = 7311545860194;
  var BLUEPRINT_VARIANT_ID = 41786120274018;
}
// ─────────────────────────────────────────────────────────────────────────────

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() { 
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      const idInput = this.form.querySelector('[name="id"]');
      if (idInput) idInput.disabled = false;

      // FBT / bundle forms use their own submit handlers (no variant input).
      if (!idInput) return;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault(); 
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      // Preserve the existing UTB page/selector IDs; purchase the native bundle.
      // These six mappings are specific to the UTB migration in this theme.
      const nativeBundleVariants = {
        "41550261485666": "50717626531938",
        "41550261518434": "50717626564706",
        "41550261551202": "50717626597474",
        "41707595137122": "50717704257634",
        "41707595169890": "50717704290402",
        "41707595202658": "50717704323170"
};
      const nativeBundleId = nativeBundleVariants[String(formData.get('id'))];
      if (nativeBundleId) formData.set('id', nativeBundleId);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      // Start the cart-state check in parallel with the main add so it's ready
      // by the time we need it — saves one sequential round-trip for bat products.
      const cartCheckPromise = fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

          if (response.status) {
            // CART ERROR EVENT
            document.dispatchEvent(
							new CustomEvent('cart:error', {
								detail: {
									source: 'product-form',
									productVariantId: formData.get('id'),
									errors: response.description,
									message: response.message,
								},
							})
            // -------------------------------------------
						)

            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // VARIANT ADDED EVENT
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source,
              },
            })
          );
          // -------------------------------------------

          fetch(`${routes.cart_url}.js`)
						.then((response) => {
							return response.text()
						})
						.then((state) => {
							const parsedState = JSON.parse(state)

							// dispatch cart:change for the entire basket
							document.dispatchEvent(
								new CustomEvent('cart:change', {
									detail: {
										cart: parsedState,
										sectionId: this.dataset.source,
									},
								})
							)
							// dispatch cart:change for the entire basket

						})
						.catch((error) => {
							console.error('Error fetching cart state:', error);
						})

          if (!this.error) {
						publish(PUB_SUB_EVENTS.cartUpdate, {
							source: 'product-form',
							productVariantId: formData.get('id'),
						})
						this.error = false
					}

          const openDrawer = (finalResponse) => {
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(finalResponse) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(finalResponse);
            }
          };

          const addedProductId = response.product_id;
          const isBaseballBat  = BAT_PRODUCT_IDS.has(addedProductId);

          if (!isBaseballBat) {
            openDrawer(response);
            return;
          }

          // Capture the bat's line-item key and variant ID from the add response
          // so we can cross-link both items after the blueprint is added.
          const batLineKey   = response.key;
          const batVariantId = response.variant_id;

          // Baseball bat added — cartCheckPromise already ran in parallel so no wait.
          // Add All Star Blueprint if missing, then cross-link both items, then open drawer.
          cartCheckPromise
            .then((cart) => {
              const existingBlueprint = cart.items.find(
                (item) => item.product_id === BLUEPRINT_PRODUCT_ID
              );
              if (existingBlueprint) {
                openDrawer(response);
                return;
              }

              const sections = this.cart.getSectionsToRender().map((s) => s.id);
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({
                  items: [{
                    id: BLUEPRINT_VARIANT_ID,
                    quantity: 1,
                    properties: {
                      _gift_with_purchase: 'true',
                      _complimentary_item: 'All Star Blueprint',
                      // Link gift → bat so the removal sync can find the parent
                      _parent_variant_id: String(batVariantId),
                    },
                  }],
                  sections,
                }),
              })
              .then((r) => r.json())
              .then((blueprintResponse) => {
                // Link bat → gift by updating the bat's line-item properties.
                // We merge with any existing properties on the bat line item so
                // nothing already set on it is lost.
                const existingBatProps = response.properties || {};
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  credentials: 'same-origin',
                  body: JSON.stringify({
                    id: batLineKey,
                    properties: {
                      ...existingBatProps,
                      // Link bat → gift variant so the removal sync can find it
                      _gift_variant_id: String(BLUEPRINT_VARIANT_ID),
                    },
                  }),
                })
                .then((r) => r.json())
                .then(() => {
                  openDrawer(Object.assign({}, response, {
                    sections: blueprintResponse.sections || response.sections,
                  }));
                });
              })
              .catch(() => openDrawer(response));
            })
            .catch(() => openDrawer(response));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// ─── Bat ↔ Blueprint removal sync ────────────────────────────────────────────
// Orphan-detection approach: on every cart:change we scan the NEW cart state
// for items that have lost their paired partner, then remove them.
//
//   Orphaned gift:   has _parent_variant_id  but parent variant is gone
//   Orphaned parent: has _gift_variant_id    but gift variant is gone
//
// No prevItems diff needed → no seed race-condition, no timing bugs.
// ─────────────────────────────────────────────────────────────────────────────
(function giftPairingSync() {
  const LOG = '[gift-sync]';
  let isSyncing = false;

  // Re-render the cart drawer after a silent removal.
  // We do NOT publish PUB_SUB_EVENTS.cartUpdate — that would trigger
  // CartDrawerItems.onCartUpdate() which injects full cart-PAGE table HTML.
  async function rerenderDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return;
    const ids      = cartDrawer.getSectionsToRender().map((s) => s.id);
    const sections = await fetch(
      window.location.pathname + '?sections=' + ids.join(','),
      { credentials: 'same-origin' }
    ).then((r) => r.json());
    const updatedCart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
    cartDrawer.renderContents({ sections }, false);
    cartDrawer.classList.toggle('is-empty', updatedCart.item_count === 0);
    console.log(LOG, 'drawer re-rendered, item_count:', updatedCart.item_count);
  }

  async function removeOrphans(keysToRemove) {
    console.log(LOG, 'removing orphan keys:', keysToRemove);
    isSyncing = true;
    try {
      for (const key of keysToRemove) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
        console.log(LOG, '  removed key:', key);
      }
      await rerenderDrawer();
    } catch (err) {
      console.error(LOG, 'error:', err);
    } finally {
      isSyncing = false;
    }
  }

  document.addEventListener('cart:change', (e) => {
    if (isSyncing) return;

    const items = e.detail?.cart?.items;
    if (!Array.isArray(items)) return;

    console.log(LOG, 'cart:change | items:', items.map((i) => i.title));

    const hasQualifyingBat = items.some((item) =>
      BAT_PRODUCT_IDS.has(item.product_id)
    );

    // Gift is in cart but its parent variant has been removed
    const orphanedGifts = items.filter((item) => {
      if (item.properties?._parent_variant_id) {
        const parentId = String(item.properties._parent_variant_id);
        const parentInCart = items.some(
          (i) => String(i.variant_id) === parentId
        );
        if (!parentInCart) {
          console.log(
            LOG,
            '  orphaned gift:',
            item.title,
            '| parent variant missing:',
            parentId
          );
          return true;
        }
      }

      // Legacy / FBT gifts without _parent_variant_id — remove when no bat remains
      if (
        !hasQualifyingBat &&
        (item.product_id === BLUEPRINT_PRODUCT_ID ||
          item.properties?._gift_with_purchase === 'true')
      ) {
        console.log(LOG, '  orphaned gift (no bat):', item.title);
        return true;
      }

      return false;
    });

    // Parent is in cart but its linked gift variant has been removed
    const orphanedParents = items.filter((item) => {
      if (!item.properties?._gift_variant_id) return false;
      const giftId = String(item.properties._gift_variant_id);
      const giftInCart = items.some((i) => String(i.variant_id) === giftId);
      if (!giftInCart) {
        console.log(
          LOG,
          '  orphaned parent:',
          item.title,
          '| gift variant missing:',
          giftId
        );
      }
      return !giftInCart;
    });

    const keysToRemove = [...new Set([
      ...orphanedGifts.map((i) => i.key),
      ...orphanedParents.map((i) => i.key),
    ])];

    if (keysToRemove.length) {
      removeOrphans(keysToRemove);
    } else {
      console.log(LOG, '  no orphans detected');
    }
  });
})();
